module.exports = __webpack_public_path__ + "img/electronicCircuit_sign.e4d53051.png";